import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { allMenus as i18nNamespace } from "../../../i18n/namespace";

export default () => {

    const dispatch = useDispatch()
    const { t } = useTranslation(i18nNamespace);
    dispatch({
        type: "NOTIFICATIONS:ERROR",
        payload: {
            message: t("something_went_wrong"),
            key: "APP-REDIRECT",
            showGlobal: true
        }
    })

    return <></>
}